/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { publicDataRemovalRequestConfirm } from '../../axios/publicDataRemovalRequestConfirm'
import type {
	PublicDataRemovalRequestConfirmError,
	PublicDataRemovalRequestConfirmPathParams,
	PublicDataRemovalRequestConfirmResponse,
} from '../../types/PublicDataRemovalRequestConfirm'

export const publicDataRemovalRequestConfirmMutationKey = () => [{ url: '/data-removal/:token/confirm' }] as const

export type PublicDataRemovalRequestConfirmMutationKey = ReturnType<typeof publicDataRemovalRequestConfirmMutationKey>

export type PublicDataRemovalRequestConfirmVariables = {
	token: PublicDataRemovalRequestConfirmPathParams['token']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PublicDataRemovalRequestController.php PublicDataRemovalRequestController::confirm */
export function usePublicDataRemovalRequestConfirm<TContext = unknown>(
	options?: UseMutationOptions<
		PublicDataRemovalRequestConfirmResponse,
		AxiosError<PublicDataRemovalRequestConfirmError>,
		PublicDataRemovalRequestConfirmVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: publicDataRemovalRequestConfirmMutationKey(),
		mutationFn: ({ token }: PublicDataRemovalRequestConfirmVariables) =>
			publicDataRemovalRequestConfirm(token, config).then(res => res.data),
		...options,
	})
}
